(function () { 
angular.module('invesfleet')
    .directive('parseDate', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ngModel) {
                function parseDates(data) {
                    return data ? new Date(data) : '';
                }

                function serializeDates(data) {
                    return data.toISOString();
                }

                ngModel.$parsers.push(serializeDates);
                ngModel.$formatters.push(parseDates);
            }
        };
    });
})();